<ng-container *ngIf="isWebSite; then landing; else cabinet"></ng-container>
<ng-template #landing>
  <header class="header landing">
    <ng-container *ngIf="isDesktop$ | async; else mobile">
      <div class="header-wrap">
        <div class="header-logo">
          <a [routerLink]="['']" class="header-logo__link">
            <img [src]="environment.LOGO_WHITE" alt="" class="header-logo-icon" height="100%" width="100%"/>
          </a>
        </div>
        <app-header-desktop-navigation
          [items]="webSiteItems"
        ></app-header-desktop-navigation>
        <div
          class="header-controls d-flex justify-content-between align-items-center"
        >
          <div class="phone">
            <a [href]="phones[0].contact" class="phone-link">{{ phones[0].label }}</a>
          </div>
          <a (click)="onNavigateToCabinet()"
             [routerLink]="'auth/login'"
             class="header-cabinet">
            {{
              "BUTTON.USER_ROOM" | translate
            }}
          </a>
        </div>
      </div>
    </ng-container>
  </header>

  <ng-template #mobile>
    <div class="header-wrap">
      <div class="header-logo">
        <a [routerLink]="['']" class="header-logo__link">
          <img [src]="environment.LOGO_WHITE" alt="" class="header-logo-icon" height="100%" width="100%"/>
        </a>
      </div>
      <app-header-mobile-navigation
        (hamburgerEvent)="hamburgerEventHandler()"
        (itemClickEvent)="hamburgerEventHandler()"
        (logoutEvent)="logoutHandler()"
        [active]="hamburger"
        [env]="environment"
        [isLogged]="isLogged$ | async"
        [isMenu]="true"
        [isWebSite]="isWebSite"
        [items]="webSiteItems"
        [phones]="phones"
      ></app-header-mobile-navigation>
      <div
        class="header-controls d-flex align-items-center justify-content-center header-controls_mobile"
      >
        <a (click)="onNavigateToCabinet()"
           [routerLink]="'auth/login'"
           class="header-cabinet">
          {{
            "BUTTON.USER_ROOM" | translate
          }}</a>
      </div>
      <div
        (click)="hamburgerEventHandler()"
        [ngClass]="{ hamburger_active: hamburger }"
        class="hamburger"
      >
        <span class="hamburger__line"></span>
      </div>
    </div>
  </ng-template>
</ng-template>

<ng-template #cabinet>
  <header class="header cabinet">
    <div class="header-wrap">
      <div class="header-inner d-flex align-items-center justify-content-between">
        <div [ngClass]="{ active: hamburger }" class="header-logo">
          <img [src]="environment.LOGO_WHITE" alt="" class="header-logo-icon" height="100%" width="100%"/>
        </div>

        <div class="header-content d-flex justify-content-end">
          <ng-container *ngIf="isLogged$ | async">
            <app-header-navigation
              (hamburgerEvent)="hamburgerEventHandler()"
              (logoutEvent)="logoutHandler()"
              [active]="hamburger"
              [env]="environment"
              [isLogged]="isLogged$ | async"
              [isMenu]="isMenu$ | async"
              [isMobile]="tabletWide$ | async"
              [navItems]="navItems"
              [phones]="phones"
            ></app-header-navigation>
          </ng-container>

          <div class="header-controls">
            <div class="phone">
              <a [href]="phones[0].contact" class="phone-link">{{ phones[0].label }}</a>
            </div>

            <ng-container *ngIf="isLogged$ | async">
              <div (click)="logoutHandler()" class="logout cursor-pointer ml-3 d-flex align-items-center" mat-mini-fab>
                <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.50004 17.292H5.00004C4.71107 17.3043 4.42252 17.2595 4.15088 17.1602C3.87925 17.0608 3.62987 16.9089 3.41702 16.7131C3.20417 16.5172 3.03202 16.2814 2.91042 16.0189C2.78882 15.7565 2.72016 15.4727 2.70837 15.1837V4.81703C2.72016 4.52804 2.78882 4.24421 2.91042 3.98179C3.03202 3.71936 3.20417 3.48349 3.41702 3.28766C3.62987 3.09184 3.87925 2.93991 4.15088 2.84056C4.42252 2.74122 4.71107 2.69641 5.00004 2.7087H7.50004C7.6658 2.7087 7.82477 2.77455 7.94198 2.89176C8.05919 3.00897 8.12504 3.16794 8.12504 3.3337C8.12504 3.49946 8.05919 3.65843 7.94198 3.77564C7.82477 3.89285 7.6658 3.9587 7.50004 3.9587H5.00004C4.7526 3.93718 4.50637 4.01173 4.31243 4.16689C4.11848 4.32205 3.9917 4.5459 3.95837 4.79203V15.1837C3.9917 15.4298 4.11848 15.6537 4.31243 15.8088C4.50637 15.964 4.7526 16.0385 5.00004 16.017H7.50004C7.6658 16.017 7.82477 16.0829 7.94198 16.2001C8.05919 16.3173 8.12504 16.4763 8.12504 16.642C8.12504 16.8078 8.05919 16.9668 7.94198 17.084C7.82477 17.2012 7.6658 17.267 7.50004 17.267V17.292Z"
                    fill="#363F72"
                  />
                  <path
                    d="M13.3335 13.9585C13.2513 13.9589 13.17 13.9428 13.0941 13.9114C13.0183 13.8799 12.9495 13.8336 12.8918 13.7751C12.7748 13.658 12.709 13.4991 12.709 13.3335C12.709 13.1678 12.7748 13.009 12.8918 12.8918L15.7835 10.0001L12.8918 7.10847C12.8304 7.05125 12.7811 6.98225 12.747 6.90559C12.7128 6.82892 12.6944 6.74616 12.693 6.66224C12.6915 6.57832 12.7069 6.49496 12.7384 6.41714C12.7698 6.33932 12.8166 6.26862 12.8759 6.20927C12.9353 6.14992 13.006 6.10314 13.0838 6.0717C13.1616 6.04027 13.245 6.02483 13.3289 6.02631C13.4128 6.02779 13.4956 6.04616 13.5722 6.08032C13.6489 6.11448 13.7179 6.16373 13.7751 6.22514L17.1085 9.55847C17.2255 9.67566 17.2912 9.83451 17.2912 10.0001C17.2912 10.1658 17.2255 10.3246 17.1085 10.4418L13.7751 13.7751C13.7174 13.8336 13.6486 13.8799 13.5728 13.9114C13.4969 13.9428 13.4156 13.9589 13.3335 13.9585Z"
                    fill="#4E5BA6"
                  />
                  <path
                    d="M16.6667 10.625H7.5C7.33424 10.625 7.17527 10.5592 7.05806 10.4419C6.94085 10.3247 6.875 10.1658 6.875 10C6.875 9.83424 6.94085 9.67527 7.05806 9.55806C7.17527 9.44085 7.33424 9.375 7.5 9.375H16.6667C16.8324 9.375 16.9914 9.44085 17.1086 9.55806C17.2258 9.67527 17.2917 9.83424 17.2917 10C17.2917 10.1658 17.2258 10.3247 17.1086 10.4419C16.9914 10.5592 16.8324 10.625 16.6667 10.625Z"
                    fill="#363F72"
                  />
                </svg>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="header-footer">
      <ng-container *ngIf="(isPreview$ | async) && (isLogged$ | async)">
        <app-loan-preview [group]="environment.group" [isLogged]="isLogged$ | async" [preview]="preview$ | async"
                          [type]="'small'"></app-loan-preview>
      </ng-container>
    </div>
  </header>
</ng-template>
